<!-- OHLC crosshair legend (top-left) -->
<div class="ohlc-legend" [class.dark]="isDark" *ngIf="crosshairOhlc">
  <span class="ohlc-name" *ngIf="symbolLabel">{{ symbolLabel }}</span>
  <span class="ohlc-tf" *ngIf="timeframeLabel">· {{ timeframeLabel }}</span>
  <span class="ohlc-tf" *ngIf="dateLabel">· {{ dateLabel }}</span>
  <ng-container *ngIf="crosshairOhlc.open !== null">
    <span class="ohlc-item">O<span class="ohlc-val">{{ crosshairOhlc.open | number:'1.5-5' }}</span></span>
    <span class="ohlc-item">H<span class="ohlc-val">{{ crosshairOhlc.high | number:'1.5-5' }}</span></span>
    <span class="ohlc-item">L<span class="ohlc-val">{{ crosshairOhlc.low | number:'1.5-5' }}</span></span>
    <span class="ohlc-item">C<span class="ohlc-val">{{ crosshairOhlc.close | number:'1.5-5' }}</span></span>
    <span class="ohlc-change" *ngIf="crosshairOhlc.change !== null"
      [class.positive]="crosshairOhlc.change! >= 0"
      [class.negative]="crosshairOhlc.change! < 0">
      {{ crosshairOhlc.change! >= 0 ? '+' : '' }}{{ crosshairOhlc.change | number:'1.5-5' }}
      ({{ crosshairOhlc.change! >= 0 ? '+' : '' }}{{ crosshairOhlc.changePct | number:'1.2-2' }}%)
    </span>
  </ng-container>
  <ng-container *ngIf="crosshairOhlc.open === null && crosshairOhlc.close !== null">
    <span class="ohlc-item">C<span class="ohlc-val">{{ crosshairOhlc.close | number:'1.2-4' }}</span></span>
  </ng-container>
  <span class="ohlc-item ohlc-bid" *ngIf="bid !== null && bid !== undefined">Bid<span class="ohlc-val">{{ bid | number:'1.5-5' }}</span></span>
  <span class="ohlc-item ohlc-ask" *ngIf="ask !== null && ask !== undefined">Ask<span class="ohlc-val">{{ ask | number:'1.5-5' }}</span></span>
</div>
<!-- Legend top-right (indicadores) -->
<div *ngIf="legendItems.length > 0" class="chart-legend" [class.dark]="isDark">
  <div class="condicion-legend-title">Indicadores</div>
  <div *ngFor="let item of legendItems" class="chart-legend-item">
    <span class="chart-legend-dot" [style.background]="item.color"></span>
    <span class="chart-legend-label">{{ item.name }}</span>
    <span class="chart-legend-value" *ngIf="item.value" [style.color]="item.color">{{ item.value }}</span>
  </div>
</div>
<!-- Condición del modelo -->
<div class="condicion-legend" [class.dark]="isDark" *ngIf="showCondiciones && (condicionEntradaLista.length || condicionSalidaLista.length)">
  <div class="condicion-legend-title">Condiciones</div>
  <div class="condicion-legend-row" *ngFor="let texto of condicionEntradaLista">
    <span class="condicion-legend-tipo entrada">Entrada</span>
    <span class="condicion-legend-text">{{ texto }}</span>
  </div>
  <div class="condicion-legend-row" *ngFor="let texto of condicionSalidaLista">
    <span class="condicion-legend-tipo salida">Salida</span>
    <span class="condicion-legend-text">{{ texto }}</span>
  </div>
</div>
